import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import EmptyMessage from "components/EmptyMessage";
import Translate from "utils/translate";
import { getUrlParams } from "utils/urlParams";

import styles from "./Dashboard.css";

const { t } = new Translate("Dashboard");

export const Dashboard = ({ dealDashboardUrl, marketingDashboardUrl }) => {
  const { type } = getUrlParams();
  let dashboardUrl = dealDashboardUrl || marketingDashboardUrl;
  if (type && type === "marketing") dashboardUrl = marketingDashboardUrl;

  return (
    <>
      {dashboardUrl ? (
        <div className={styles.dashboard}>
          <iframe src={dashboardUrl} title="dashboard" />
        </div>
      ) : (
        <EmptyMessage text={t("empty")} />
      )}
    </>
  );
};

Dashboard.propTypes = {
  dealDashboardUrl: PropTypes.string,
  marketingDashboardUrl: PropTypes.string,
};

const mapStateToProps = ({ currentUser: { company } }) => ({
  dealDashboardUrl: company.dealDashboardUrl,
  marketingDashboardUrl: company.marketingDashboardUrl,
});

export default connect(mapStateToProps)(Dashboard);
